import BackButton from '@components/BackButton/BackButton'
import { Link } from 'react-router'
import Breadcrumb, { Crumb } from '@components/Breadcrumb/Breadcrumb'
import MenuButton from '@components/MenuButton/MenuButton'

import symbol from '@static/vectors/icon-datalab.svg'
import './ExternalHeaderContent.css'

interface ExternalHeaderContentProps {
  hasBack?: boolean
  crumbs?: Crumb[]
  className?: string
  headerActions?: React.ReactNode
  hasMenu?: boolean
}

export default function ExternalHeaderContent({
  crumbs = [],
  className = '',
  hasBack = false,
  headerActions,
  hasMenu = true
}: ExternalHeaderContentProps) {
  return (
    <div className={`external-header ${className}`}>
      <div>
        {hasBack ? (
          <BackButton />
        ) : (
          <Link className="only-responsive" to="/">
            <img src={symbol} alt="datalab icon" />
          </Link>
        )}
      </div>
      <div>
        <Breadcrumb crumbs={crumbs} />
      </div>
      <div>
        {headerActions}
        {hasMenu && <MenuButton />}
      </div>
    </div>
  )
}
